export const MY_LOAD_LORRY_TABS = {
    LISTING: "listing",
    BIDS: "bids"
};
